/** Standard MusicXML `other-play` discriminator for this app's typed Feel cue. */
export const MUSICXML_FEEL_OTHER_PLAY_TYPE = 'scoreguard-feel';

/** Keeps a conductor-track annotation separate from words on one part's note. */
export const MUSICXML_FORM_TEXT_OTHER_PLAY_TYPE = 'scoreguard-form-text';

/**
 * Standard MusicXML `miscellaneous-field` name carrying a Part's semantic
 * role (lead/comp/bass/other) inside its `<score-part><identification>`.
 * MusicXML has no role vocabulary of its own, and without this a round trip
 * loses which part is the melody — the chart projection then falls back to
 * part ORDER, which is presentation, not meaning.
 */
export const MUSICXML_PART_ROLE_FIELD = 'scoreguard-part-role';
/** Which passes an authored part sounds on (`Part.playOn`), beside the role. */
export const MUSICXML_PART_PLAY_ON_FIELD = 'scoreguard-part-play-on';
